var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-container" }, [
      _c("div", { staticClass: "modal-header" }, [
        _vm._v(
          "\n            " + _vm._s(_vm.action) + " Subscription\n            "
        ),
        _c("div", {
          staticClass: "delete is-large is-pulled-right",
          on: { click: _vm.doClose }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("form", [
          _c("div", { staticClass: "is-size-3 left10" }, [
            _vm._v(
              "\n                    " + _vm._s(_vm.id) + "\n                "
            )
          ]),
          _vm._v(" "),
          this.toDo == "renew"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v(
                  "\n                    This subscription's renewal has been added to your cart. Once you complete the checkout process, the subscription period will be extended and your slinks and subslinks will be re-activated.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.toDo == "cancel"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v(
                  "\n                    This subscription will be removed from your automatic renewals. It will not be billed again on its renewal date. It will, however, remain active until that date.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          this.toDo == "reinstate"
            ? _c("div", { staticClass: "top20 left10" }, [
                _vm._v(
                  "\n                    This subscription  will be reinstated.  It will be billed and extended on its next renewal date.\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "top20 left10" }, [
            _c(
              "button",
              {
                staticClass: "button is-warning",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.save.apply(null, arguments)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.action.toUpperCase()))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button left10",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.doClose.apply(null, arguments)
                  }
                }
              },
              [_vm._v("CANCEL")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [_c("div")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ebaea70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ebaea70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAddRemSubscr.vue
// module id = null
// module chunks = 